import React, { useState } from 'react';
import { MoreHorizontal, LogOut } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { NAV_ITEMS, BOTTOM_NAV_IDS } from '../navItems';

/**
 * The phone navigation bar: four destinations plus More.
 *
 * Everything that does not fit on the bar lives in the More sheet, Logout
 * included - on a phone the sidebar footer that holds it is not on screen.
 */
const BottomNav = ({ currentPage, onNavigate, onLogout }) => {
  const { print_lang } = useLanguage();
  const [sheetOpen, setSheetOpen] = useState(false);

  const barItems = BOTTOM_NAV_IDS.map((id) => NAV_ITEMS.find((item) => item.id === id));
  const sheetItems = NAV_ITEMS.filter((item) => !BOTTOM_NAV_IDS.includes(item.id));
  const moreIsActive = !BOTTOM_NAV_IDS.includes(currentPage);

  const go = (id) => {
    setSheetOpen(false);
    onNavigate(id);
  };

  return (
    <>
      {sheetOpen && (
        <>
          <div className="more-sheet-scrim" onClick={() => setSheetOpen(false)} />
          <div className="more-sheet" role="dialog" aria-label={print_lang('menu', 'Menu')}>
            <div className="more-sheet-handle" />
            <ul className="more-sheet-list">
              {sheetItems.map(({ id, labelKey, labelFallback, Icon }) => (
                <li key={id}>
                  <button
                    type="button"
                    className={`more-sheet-item ${currentPage === id ? 'active' : ''}`}
                    onClick={() => go(id)}
                  >
                    <Icon className="more-sheet-icon" aria-hidden="true" />
                    {print_lang(labelKey, labelFallback)}
                  </button>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  className="more-sheet-item more-sheet-item-danger"
                  onClick={() => { setSheetOpen(false); onLogout(); }}
                >
                  <LogOut className="more-sheet-icon" aria-hidden="true" />
                  {print_lang('logout', 'Logout')}
                </button>
              </li>
            </ul>
          </div>
        </>
      )}

      <nav className="bottom-nav" aria-label={print_lang('menu', 'Menu')}>
        {barItems.map(({ id, labelKey, labelFallback, Icon }) => (
          <button
            key={id}
            type="button"
            className={`bottom-nav-item ${currentPage === id ? 'active' : ''}`}
            onClick={() => go(id)}
          >
            <Icon className="bottom-nav-icon" aria-hidden="true" />
            <span className="bottom-nav-label">{print_lang(labelKey, labelFallback)}</span>
          </button>
        ))}

        <button
          type="button"
          className={`bottom-nav-item ${moreIsActive ? 'active' : ''}`}
          onClick={() => setSheetOpen((open) => !open)}
          aria-expanded={sheetOpen}
        >
          <MoreHorizontal className="bottom-nav-icon" aria-hidden="true" />
          <span className="bottom-nav-label">{print_lang('more', 'More')}</span>
        </button>
      </nav>
    </>
  );
};

export default BottomNav;
